module.exports = __webpack_public_path__ + "static/media/plane.64e0c441.png";